import { gql } from "@apollo/client"

// GET SERVER IP
export const GET_SERVER_IP = gql`
  query ServerIp {
    system{
      serverIp
    }  
  }
`